import { lazy } from "react"

export const AUCTION_MODALS = {
  auctionInfo: {
    component: lazy(() => import("modals/ui/auction/AuctionInfoModal"))
  },
  auctionFinished: {
    component: lazy(() => import("modals/ui/auction/AuctionFinishedModal"))
  }
} as const
